import { EinzaApiService } from "@/services/einzaApi"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getArticlesBySku } from "../../shared/utils/getArticleInformation"

export const queryMixArticles = {
  async mixArticles(_parent, args, context, _info) {
    const { productId, collectionId, colorId, branchId, customerNumber } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.MIXED_PRODUCTS,
      operation: Operations.READ,
    })

    const method = `artikel/list2/${productId}/${collectionId}/${colorId}`
    const einzaResponse = (await EinzaApiService.getData(method))?.data

    if (!einzaResponse?.length) {
      return { total: 0, items: [] }
    }

    const articles = await getArticlesBySku({
      context,
      skus: einzaResponse.map((article) => article.artikelNr),
      branchId,
      customerNumber,
    })

    if (!articles?.length) {
      return { total: 0, items: [] }
    }

    return {
      total: articles.length,
      items: articles,
    }
  },
}
